// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__26Ie4","row":"ProcedureTreatmentSummary_row__1JTfC"};